import fetcher from 'api/fetcher';
import { AxiosError } from 'axios';
import { push } from 'connected-react-router';
import { getBannerImages } from 'utils/banner/utils';
import { BannerImagesData } from 'utils/clickme';
import { BannerImageCropType } from 'utils/constants/banner';
import { MagritteNotificationName } from 'utils/constants/notification';

import bannerCreateCropSaveFormSubmit from '@hh.ru/analytics-js-events/build/clickme/employer/common/banner_create_crop_save_form_submit';

import { addMagritteNotification } from 'store/models/notification';
import { AppThunkAction } from 'store/utils';

type SaveBanner = (
    activeCropTypes: BannerImageCropType[],
    dashboardRoute: string,
    needRedirectAfterSave?: boolean
) => AppThunkAction;

type BannerBody = {
    campaignId: number;
    title: string;
    url: string;
    text: string;
    bannerImages: BannerImagesData[];
    bannerVideo: {
        width?: number;
        height?: number;
        videoUploadId?: string;
        thumbnailUploadId?: string;
    } | null;
    classificationCodeId: string | null;
    isAdvertisement: boolean;
    id?: number;
};

export const saveBanner: SaveBanner = (activeCropTypes, dashboardRoute, needRedirectAfterSave = true) => {
    return (dispatch, getState) => {
        const { createBanner } = getState();
        const {
            bannerTitle,
            bannerLink,
            bannerText,
            campaignIdForBanner,
            bannerId,
            images,
            bannerVideo,
            classificationCodeId,
            isAdvertisement,
        } = createBanner;
        const bannerImages = getBannerImages(images, activeCropTypes);

        const campaignIdNum = Number(campaignIdForBanner);

        const body: BannerBody = {
            campaignId: campaignIdNum,
            title: bannerTitle,
            url: bannerLink,
            text: bannerText,
            bannerImages,
            bannerVideo: null,
            classificationCodeId,
            isAdvertisement,
        };

        if (bannerVideo) {
            const { width, height, videoUploadId, thumbnailUploadId } = bannerVideo;
            body.bannerVideo = {
                width,
                height,
                videoUploadId,
                thumbnailUploadId,
            };
        }

        let method: 'post' | 'put' = 'post';
        let path = `/api/v1/campaigns/${campaignIdNum}/banners`;
        if (bannerId) {
            body.id = bannerId;
            method = 'put';
            path = '/api/v1/banners';
        }
        return fetcher[method](path, body)
            .then(() => {
                if (!bannerId) {
                    bannerCreateCropSaveFormSubmit({
                        campaignId: campaignIdNum,
                        title: bannerTitle,
                        text: bannerText,
                        url: bannerLink,
                    });
                }
                if (needRedirectAfterSave) {
                    dispatch(push(dashboardRoute));
                }
            })
            .catch((errors: AxiosError) => {
                if (!bannerId) {
                    bannerCreateCropSaveFormSubmit({
                        campaignId: campaignIdNum,
                        title: bannerTitle,
                        text: bannerText,
                        url: bannerLink,
                        errors: JSON.stringify(errors),
                    });
                }
                if (errors?.response?.status === 400) {
                    dispatch(addMagritteNotification(MagritteNotificationName.CreateBannerSomethingWentWrongError));
                }
                throw errors;
            });
    };
};
